const prefixes = {
  moz: '-moz-',
  o: '-o-',
  ms: '-ms-',
  webkit: '-webkit-',
};
// css properties should never be in 2 or more lists, it should only be in 1.
const types = {
  // properties are for css rules that need only property prefixes
  properties: [
    {
      name: 'transform',
      list: ['transform', `${prefixes.webkit}transform`, `${prefixes.ms}transform`, `${prefixes.o}transform`],
    },
    {
      name: 'box-shadow',
      list: ['box-shadow', `${prefixes.webkit}box-shadow`, `${prefixes.ms}box-shadow`, `${prefixes.o}box-shadow`],
    },
    {
      name: 'justify-content',
      list: ['justify-content', `${prefixes.webkit}box-pack`, `${prefixes.ms}flex-pack`],
    },
    {
      name: 'align-items',
      list: ['align-items', `${prefixes.webkit}box-align`, `${prefixes.ms}flex-align`],
    },
    {
      name: 'transform-style',
      list: ['transform-style', `${prefixes.webkit}transform-style`],
    },
    {
      name: 'transition-delay',
      list: ['transition-delay', `${prefixes.webkit}transition-delay`, `${prefixes.o}transition-delay`],
    },
  ],
  // values are for css rules that need both values and property prefixes. In this
  // case you will need the default property and value in addition to the prefix ones.
  values: [
    {
      name: 'display',
      list: (value) => {
        const list = [{
          property: 'display',
          value,
        }];
        if (value === 'flex') {
          list.push(
            {
              property: 'display',
              value: `${prefixes.ms}flexbox`,
            },
          );
        }
        if (value === 'grid') {
          list.push({
            property: 'display',
            value: `${prefixes.ms}grid`,
          });
        }
        return list;
      },
    },
    {
      name: 'grid-template-columns',
      list: (value) => {
        const list = [{
          property: 'grid-template-columns',
          value,
        }];
        if (value.match(/repeat\(auto-fit,|repeat\(auto-fill,/gi)) {
          const autoVal = value.match(/repeat(([^,]+))/gi)[0].split('(')[1].trim();
          const minVal = value.match(/minmax(([^,]+))/gi)[0].split('(')[1].trim();
          const maxVal = value.match(/minmax(([^)]+))/gi)[0].split(',')[1].trim();
          list.push({
            property: `${prefixes.ms}grid-columns`,
            value: `(minmax(${minVal}, ${maxVal}))[${autoVal}]`,
          });
        } else {
          const repeatAmount = value.match(/repeat(([^,]+))/gi)[0].split('(')[1].trim();
          const spanAmount = value.match(/\((([^)]+))/gi)[0].split(',')[1].trim();
          list.push({
            property: `${prefixes.ms}grid-columns`,
            value: `(${spanAmount})[${repeatAmount}]`,
          });
        }
        return list;
      },
    },
    {
      name: 'grid-area',
      list: (value) => {
        const list = [{
          property: 'grid-area',
          value,
        }];
        if (value !== 'initial') {
          const values = value.split('/').map(n => ~~(n.trim()));
          const rowStart = values[0];
          const rowEnd = values[2];
          const colStart = values[1];
          const colEnd = values[3];
          // rows
          list.push({
            property: `${prefixes.ms}grid-row`,
            value: rowStart,
          });
          const rowSpan = rowEnd - rowStart;
          if (rowSpan > 0) {
            list.push({
              property: `${prefixes.ms}grid-row-span`,
              value: rowSpan,
            });
          }
          // columns
          list.push({
            property: `${prefixes.ms}grid-column`,
            value: colStart,
          });
          const colSpan = colEnd - colStart;
          if (colSpan > 0) {
            list.push({
              property: `${prefixes.ms}grid-column-span`,
              value: colSpan,
            });
          }
        } else if (value === 'initial') {
          list.push(
            {
              property: `${prefixes.ms}grid-row`,
              value: 'initial',
            },
            {
              property: `${prefixes.ms}grid-row-span`,
              value: 'initial',
            },
            {
              property: `${prefixes.ms}grid-column`,
              value: 'initial',
            },
            {
              property: `${prefixes.ms}grid-column-span`,
              value: 'initial',
            },
          );
        }
        return list;
      },
    },
  ],
  // selectors are for css rules that only need selector vendor prefixes.
  // this does not alter the property or values of the selector
  selectors: [
    {
      name: '::selection',
      list: ['::selection', `::${prefixes.moz}selection`],
    },
  ],
};

module.exports = {
  needsPrefix(name, type) {
    let prefixes = types[type].find(p => p.name === name);
    if (prefixes) {
      prefixes = prefixes.list;
    }
    return prefixes;
  },
  needsValuePrefix(name, type, value) {
    let prefixes = types[type].find(p => p.name === name);
    if (prefixes) {
      prefixes = prefixes.list(value);
    }
    return prefixes;
  },
};



// WEBPACK FOOTER //
// ./src/mixins/helpers/vendor-prefixes.js